import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import HeroImage from "../../assets/images/landingpage/heroImage.png";
import Header from "./Landingpage/Subcomponents/Header";
import SocialProof from "./Landingpage/Subcomponents/SocialProof";
import TargetGroups from "./Landingpage/Subcomponents/TargetGroups";
import FeatureVideo from "./Landingpage/Subcomponents/FeatureVideo";
import BlogCard from "../blog/BlogCard";
import blogclient from "@serie3/common/api/blogClient";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Landingpage = ({ currentLanguage, setCurrentLanguage }) => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [blogLoading, setBlogLoading] = useState(true);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (window.location.hash === "#features") {
      const element = document.getElementById("features");
      if (element) element.scrollIntoView({ behavior: "smooth" });
    }
    const loadData = async () => {
      try {
        const response = await blogclient.get();
        if (response.status === 200) setBlogPosts([...response.data.subpages]);
      } finally {
        setBlogLoading(false);
      }
    };
    loadData();
  }, []);

  return (
    <div>
      <Header currentLanguage={currentLanguage} setCurrentLanguage={setCurrentLanguage}>
        <Row className="justify-content-between align-items-center">
          <Col md={5} xs={12} className="mb-5">
            <h1 className="heroHeader">{t("Landingpage.HeroHeader")}</h1>
            <p style={{ fontSize: 18, color: "#4b5563", lineHeight: "30px", marginBottom: 36, fontFamily: "Montserrat, sans-serif" }}>
              {t("Landingpage.HeroText")}
            </p>
            <div style={{ display: "flex", gap: 16, flexWrap: "wrap", alignItems: "center" }}>
              <button className="actionButton" onClick={() => navigate('/signup')}>
                {t("Landingpage.HeroButton")}
              </button>
            </div>
          </Col>
          <Col md={6} xs={12}>
            <img src={HeroImage} style={{ maxWidth: "100%", borderRadius: 20, boxShadow: "0 20px 60px rgba(0,0,0,0.12)" }} alt="" />
          </Col>
        </Row>
      </Header>

      <SocialProof />
      <TargetGroups />
      <FeatureVideo />

      <Container style={{ marginBottom: "120px" }}>
        <h3 style={{ marginBottom: "60px" }}>{t("Landingpage.Blog.Title")}</h3>
        {blogLoading ? (
          <Row>
            {[1, 2].map((i) => (
              <Col md={6} key={i} className="mb-3">
                <div style={{ borderRadius: 18, border: "1px solid #eaecf0", padding: 24, background: "#fff" }}>
                  <div className="lp-skeleton" style={{ height: 200, borderRadius: 10, marginBottom: 20 }} />
                  <div className="lp-skeleton" style={{ height: 24, width: "70%", borderRadius: 6, marginBottom: 12 }} />
                  <div className="lp-skeleton" style={{ height: 16, width: "90%", borderRadius: 6, marginBottom: 8 }} />
                  <div className="lp-skeleton" style={{ height: 16, width: "60%", borderRadius: 6 }} />
                </div>
              </Col>
            ))}
          </Row>
        ) : (
          <Row>
            {blogPosts.map((post, index) => <BlogCard size={6} post={post} key={index} />)}
          </Row>
        )}
      </Container>
    </div>
  );
};

export default Landingpage;
